const KEY = 'ExpressWizard';

export const getExistingData = () => {
  const existingData = sessionStorage.getItem(KEY);
  if (existingData) {
    return JSON.parse(existingData);
  }

  return {};
}

export const saveItem = (value: {}) => {
  const existingData = getExistingData();
  const updatedData = {
    ...existingData,
    ...value,
  };
  sessionStorage.setItem(KEY, JSON.stringify(updatedData));
}

export const hasData = () => {
  return Object.keys(getExistingData()).length > 0;
};

export const clearData = () => {
  sessionStorage.removeItem(KEY);
}
